/* eslint-disable no-restricted-globals */
/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _forEach from 'lodash/forEach'
import _cloneDeep from 'lodash/cloneDeep'
import _find from 'lodash/find'
import {get_chip_equip_list} from "~/pages/store/reducers";
import _map from "lodash/map";

export const getHoursMin = (sec, t) => {
  sec = Number(sec)
  if (sec > 0 && sec <= 3600) {
    return '1H'
  }
  if (sec > 3600 && sec <= 86400) {
    const min = Math.floor((sec % 3600) / 60)
    return `${Math.floor(sec / 3600)}H${min <= 0 ? '' : `${min}M`}`
  }
  if (sec > 86400) {
    const hour = Math.floor((sec % 86400) / 3600)
    const day = Math.floor(sec / 86400)
    if (day > 1825) {
      return t ? t('永久') : '永久'
    }
    return `${day}D${hour <= 0 ? '' : `${hour}H`}`
  }
  return '0H'
}

/** 秒级时长：不足1小时 Min，不足1天 H，否则 D */
export const formatDayTime = (time: number) => {
  if (!time || time <= 0) return ''
  if (time < 3600) return `${Math.max(1, Math.ceil(time / 60))}Min`
  if (time < 86400) return `${Math.floor(time / 3600)}H`
  return `${Math.floor(time / 86400)}D`
}


export enum PrivateTypeEnum {
  头像框 = 1,
  进场特效 = 2,
  弹幕气泡特效 = 3,
  个人资料特权 = 4,
  声纹特权 = 5,
  上麦特权 = 6,
  称号牌 = 7,
  进场通知 = 8,
  多彩气泡 = 9,
  个人页动效 = 10,
  聊天背景 = 11,
  置顶消息皮肤 = 12,
  碎片 = 1000,
  主页皮肤 = 13,
}

export enum WearStatusEnum {
  未穿戴 = 0,
  已穿戴 = 1,
}

const formatRes = (data, curObj) => {
  const obj = {}
  for (let i = 1; i <= 13; i++) {
    obj[i] = {
      total: 0,
      list: [],
      curSelected: {},
    }
  }
  obj[PrivateTypeEnum.碎片] = {
    total: 0,
    list: [],
    curSelected: {},
  }
  _forEach(data?.list, (item) => {
    const curSelected =
      _find(item.list, (li) => li.wear_status === WearStatusEnum.已穿戴) || {}
    obj[item.type] = {
      total: item.total,
      list: item.list,
      curSelected: curObj[item.type]?.curSelected || curSelected,
    }
  })
  return {
    user: {
      avatar: data?.avatar,
      name: data?.nick_name,
    },
    obj,
    enter_room_msg_map: data.enter_room_msg_map,
  }
}

export const get_outfit_homepage = createAsyncThunk(
  'PersonalDressUp/get_outfit_homepage',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/get_outfit_homepage',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_privileges_by_mid = createAsyncThunk(
  'PersonalDressUp/get_privileges_by_mid',
  async (p: any, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/privilege/get_privileges_by_mid',
      {
        mid: deviceinfo.h_m,
      },
      {store, xcErrorToast: true}
    )
    return formatRes(resp.data.data, store.getState().PersonalDressUp.obj)
  }
)
export const query_privilege_effect = createAsyncThunk(
  'PersonalDressUp/query_privilege_effect',
  async (params: any, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/privilege/query_privilege_effect',
      {
        mid: deviceinfo.h_m,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const update_wear_status = createAsyncThunk(
  'PersonalDressUp/update_wear_status',
  async (p: any, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/privilege/update_wear_status',
      {
        mid: deviceinfo.h_m,
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const equip_buy = createAsyncThunk(
  'PersonalDressUp/equip_buy',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/equip_buy',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

const get_privilege_custom_content = async (params: any, store: any) => {
  const resp = await http.post(
      '/live/privilege/get_privilege_custom_content',
      {
        ...params,
      },
      {store, xcErrorToast: true}
  )
  return resp.data.data?.list || []
}
export const get_privilege_custom_content_flags = createAsyncThunk(
    'PersonalDressUp/get_privilege_custom_content_flags',
    (params: any, store: any) => {
      return get_privilege_custom_content({type: 1}, store)
    }
)
export const get_privilege_custom_content_texts = createAsyncThunk(
    'PersonalDressUp/get_privilege_custom_content_texts',
    (params: any, store: any) => {
      return get_privilege_custom_content({type: 2}, store)
    }
)

const get_equip_list_v2 = async (p: any, store: any) => {
    const resp = await http.post(
        '/live/privilege/get_equip_list_v2',
        {
            ...p,
            offset: 0,
            limit: 1000,
            from: "personalDreesUp",
        },
        {store, xcErrorToast: true}
    )
    const {equipments = []} = resp.data.data || {}
    return {
        ...(resp.data.data || {}),
        equipments: _map(equipments, equip => {
            const {coin_store_goods_id, privilege_id} = equip
            return {
                ...equip,
                other_zx: privilege_id,
                privilege_id: coin_store_goods_id,
            }
        })
    }
}

export const get_equip_list_v2_avatar = createAsyncThunk(
    'PersonalDressUp/get_equip_list_v2_avatar',
    (params: any, store: any) => {
        return get_equip_list_v2({tab_name: "pendant"}, store)
    }
)
export const get_equip_list_v2_car = createAsyncThunk(
    'PersonalDressUp/get_equip_list_v2_car',
    (params: any, store: any) => {
        return get_equip_list_v2({tab_name: "car"}, store)
    }
)
export const get_equip_list_v2_chat = createAsyncThunk(
    'PersonalDressUp/get_equip_list_v2_chat',
    (params: any, store: any) => {
        return get_equip_list_v2({tab_name: "dmk_bubble"}, store)
    }
)
export const get_equip_list_v2_card = createAsyncThunk(
    'PersonalDressUp/get_equip_list_v2_card',
    (params: any, store: any) => {
        return get_equip_list_v2({tab_name: "personal card"}, store)
    }
)
export const get_equip_list_v2_title = createAsyncThunk(
    'PersonalDressUp/get_equip_list_v2_title',
    (params: any, store: any) => {
        return get_equip_list_v2({tab_name: "title"}, store)
    }
)

const initialState: {
  base: any
  user: any
  obj: any
  curPrivateType: PrivateTypeEnum
  enter_room_msg_map: any
  recommend: any
  customize: {
    flags: Array<any>
    texts: Array<any>
  }
  curCustomizeInfo: any
} = {
  base: {
    showGuide1: false,
    showGuide2: false,
    showGuide3: false,
  },
  user: {},
  obj: {},
  curPrivateType: PrivateTypeEnum.碎片,
  enter_room_msg_map: {},
  recommend: {
      avatar: {},
      car: {},
      chat: {},
      card: {},
      title: {},
  },
  curCustomizeInfo: {},
  customize: {
    flags: [],
    texts: [],
  }
}

export const PersonalDressUpSlice = createSlice({
  name: 'PersonalDressUp',
  initialState,
  reducers: {
    updateShowGuide: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        base: {
          ...state.base,
          ...action.payload,
        },
      })
    },
    updatePrivateType: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        curPrivateType: action.payload,
      })
    },
    updateCurCustomizeInfo: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
          curCustomizeInfo: action.payload,
      })
    },
    updateCurSelected: (state, action: PayloadAction<any>) => {
      const obj = _cloneDeep(state.obj)
      obj[state.curPrivateType].curSelected = action.payload
      Object.assign(state, {
        obj,
      })
    },
    updateList: (state, action: PayloadAction<any>) => {
      const obj = _cloneDeep(state.obj)
      obj[state.curPrivateType]?.list?.forEach((item) => {
        item.wear_status = WearStatusEnum.未穿戴
      })
      const idx = obj[state.curPrivateType]?.list?.findIndex(
        (item) => item.privilege_id === action.payload?.privilege_id
      )
      obj[state.curPrivateType].list[idx] = action.payload
      Object.assign(state, {
        obj,
      })
    },
    updateItemCustomize: (state, action: PayloadAction<any>) => {
      const obj = _cloneDeep(state.obj)
      const bucket = obj[state.curPrivateType]
      if (!bucket) {
        return
      }
      const payload = action.payload
      if (bucket.curSelected?.privilege_id === payload?.privilege_id) {
        bucket.curSelected = payload
      }
      const idx = bucket.list?.findIndex(
        (item) => item.privilege_id === payload?.privilege_id
      )
      if (idx >= 0) {
        const wearStatus = bucket.list[idx].wear_status
        bucket.list[idx] = {
          ...payload,
          wear_status: wearStatus,
        }
      }
      Object.assign(state, {
        obj,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_privileges_by_mid.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(get_equip_list_v2_avatar.fulfilled, (state, action) => {
      Object.assign(state.recommend.avatar, action.payload)
    })
    builder.addCase(get_equip_list_v2_car.fulfilled, (state, action) => {
      Object.assign(state.recommend.car, action.payload)
    })
    builder.addCase(get_equip_list_v2_chat.fulfilled, (state, action) => {
      Object.assign(state.recommend.chat, action.payload)
    })
    builder.addCase(get_equip_list_v2_card.fulfilled, (state, action) => {
      Object.assign(state.recommend.card, action.payload)
    })
    builder.addCase(get_equip_list_v2_title.fulfilled, (state, action) => {
      Object.assign(state.recommend.title, action.payload)
    })
    builder.addCase(get_privilege_custom_content_flags.fulfilled, (state, action) => {
      Object.assign(state.customize, {
        flags: action.payload
      })
    })
    builder.addCase(get_privilege_custom_content_texts.fulfilled, (state, action) => {
      Object.assign(state.customize, {
        texts: action.payload
      })
    })
  },
})

export const usePersonalDressUp = () =>
  useSelector((store) => store.PersonalDressUp)

export default PersonalDressUpSlice.reducer
export const PersonalDressUpActions = PersonalDressUpSlice.actions
